if (!customElements.get('vivico-edition-rail')) {
  customElements.define('vivico-edition-rail', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('ul');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        this.scroller.scrollBy({ left: Number(button.dataset.direction) * this.scroller.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.scroller.addEventListener('scroll', () => this.updateButtons(), options);
      this.resize = new ResizeObserver(() => this.updateButtons());
      this.resize.observe(this.scroller);
      this.updateButtons();
    }
    updateButtons() {
      this.previous.disabled = this.scroller.scrollLeft <= 2;
      this.next.disabled = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 2;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
